export const COMPARISON_ROWS = [
  {
    criterion: 'Format de jeu',
    kartquiz:  'Course de kart live multi-joueur',
    kahoot:    'Quiz linéaire synchrone',
    quizizz:   'Quiz self-paced',
    wooclap:   'Polling + quiz',
    blooket:   'Multi mini-jeux',
  },
  {
    criterion: 'Interaction entre joueurs',
    kartquiz:  { value: true,    label: "Bonus d'attaque / défense" },
    kahoot:    { value: false,   label: 'Aucune' },
    quizizz:   { value: false,   label: 'Aucune' },
    wooclap:   { value: false,   label: 'Aucune' },
    blooket:   { value: 'mid',   label: 'Limitée' },
  },
  {
    criterion: 'Génération de quiz par IA',
    kartquiz:  { value: true,    label: 'Native' },
    kahoot:    { value: 'mid',   label: 'Payante' },
    quizizz:   { value: 'mid',   label: 'Payante' },
    wooclap:   { value: 'mid',   label: 'Payante' },
    blooket:   { value: false,   label: '—' },
  },
  {
    criterion: 'Synthèse pédagogique fine',
    kartquiz:  { value: true,    label: 'Par élève + classe' },
    kahoot:    { value: 'mid',   label: 'Payante' },
    quizizz:   { value: 'mid',   label: 'Payante' },
    wooclap:   { value: 'mid',   label: 'Payante' },
    blooket:   { value: 'mid',   label: 'Limitée' },
  },
  {
    criterion: 'Reposer les mauvaises réponses',
    kartquiz:  { value: true,    label: 'Automatique' },
    kahoot:    { value: false,   label: '—' },
    quizizz:   { value: 'mid',   label: 'Manuel' },
    wooclap:   { value: false,   label: '—' },
    blooket:   { value: 'mid',   label: 'Limité' },
  },
  {
    criterion: 'Sans inscription élève',
    kartquiz:  { value: true,    label: '✓' },
    kahoot:    { value: true,    label: '✓' },
    quizizz:   { value: true,    label: '✓' },
    wooclap:   { value: true,    label: '✓' },
    blooket:   { value: true,    label: '✓' },
  },
  {
    criterion: 'Sans app à installer',
    kartquiz:  { value: true,    label: '✓' },
    kahoot:    { value: 'mid',   label: '✓ (ou app)' },
    quizizz:   { value: 'mid',   label: '✓ (ou app)' },
    wooclap:   { value: true,    label: '✓' },
    blooket:   { value: true,    label: '✓' },
  },
  {
    criterion: 'Limite joueurs (free)',
    kartquiz:  { value: true,    label: 'Bêta : 30' },
    kahoot:    { value: false,   label: '10 joueurs' },
    quizizz:   { value: true,    label: '100 joueurs' },
    wooclap:   { value: true,    label: '1000 (polling)' },
    blooket:   { value: 'mid',   label: '60 joueurs' },
  },
  {
    criterion: 'Adapté collège / lycée / sup',
    kartquiz:  { value: true,    label: 'Cartoon adulte' },
    kahoot:    { value: true,    label: '✓' },
    quizizz:   { value: true,    label: '✓' },
    wooclap:   { value: 'mid',   label: 'Surtout sup' },
    blooket:   { value: 'mid',   label: 'Trop enfantin' },
  },
  {
    criterion: 'Tarif',
    kartquiz:  { value: true,    label: 'Gratuit (bêta)' },
    kahoot:    { value: false,   label: '3,99 – 9,99 $/mois' },
    quizizz:   { value: 'mid',   label: 'Sur devis' },
    wooclap:   { value: false,   label: '9,99 $/mois' },
    blooket:   { value: 'mid',   label: '2,99 – 8,99 $/mois' },
  },
  {
    criterion: 'Origine',
    kartquiz:  { value: true,    label: '🇫🇷 France' },
    kahoot:    { value: 'mid',   label: '🇳🇴 Norvège' },
    quizizz:   { value: 'mid',   label: '🇮🇳 Inde / 🇺🇸 USA' },
    wooclap:   { value: true,    label: '🇧🇪 Belgique' },
    blooket:   { value: 'mid',   label: '🇺🇸 USA' },
  },
  {
    criterion: 'Hébergement RGPD',
    kartquiz:  { value: true,    label: '🇪🇺 Europe' },
    kahoot:    { value: false,   label: 'Hors UE' },
    quizizz:   { value: false,   label: 'Hors UE' },
    wooclap:   { value: true,    label: '🇪🇺 UE' },
    blooket:   { value: false,   label: 'Hors UE' },
  },
]

export const WHEN_TO_CHOOSE = [
  {
    tool: 'KartQuiz',
    emoji: '🏎️',
    highlight: true,
    reasons: [
      "Tu veux une mécanique multi-joueur où l'interaction crée le suspense",
      'Tu enseignes au collège, lycée ou supérieur (univers cartoon adulte)',
      "Tu veux générer un quiz en 30 secondes avec l'IA",
      'Tu veux une synthèse de fin qui pointe les notions à retravailler',
      'Tu préfères un outil français hébergé en Europe',
    ],
  },
  {
    tool: 'Kahoot',
    emoji: '🎯',
    highlight: false,
    reasons: [
      'Tu veux la marque la plus connue et la plus grande bibliothèque communautaire',
      "Tu animes en entreprise avec besoin d'intégrations Teams, Zoom, etc.",
    ],
  },
  {
    tool: 'Quizizz',
    emoji: '📱',
    highlight: false,
    reasons: [
      'Tu veux donner des quiz en devoir asynchrone à la maison',
      'Tu privilégies le rythme individuel sur la dynamique de groupe',
    ],
  },
  {
    tool: 'Wooclap',
    emoji: '🎓',
    highlight: false,
    reasons: [
      'Tu fais surtout du polling / sondage en amphi (enseignement supérieur)',
      'Tu veux des questions ouvertes, des nuages de mots',
    ],
  },
  {
    tool: 'Blooket',
    emoji: '🎮',
    highlight: false,
    reasons: [
      'Tu enseignes en primaire et tes élèves adorent les modes de jeu variés',
    ],
  },
]

export const FAQ_COMPARISON = [
  {
    q: 'KartQuiz est-il une alternative gratuite à Kahoot ?',
    a: "Oui. Pendant la bêta, KartQuiz est entièrement gratuit, sans limite sur le nombre de joueurs. Il est une alternative française à Kahoot, avec une mécanique de course multi-joueurs, des bonus d'attaque/défense entre joueurs, et une génération de quiz par IA incluse. Kahoot est en revanche plus riche en bibliothèque communautaire et en intégrations d'entreprise.",
  },
  {
    q: 'Quelle est la différence entre KartQuiz et Quizizz ?',
    a: "Quizizz est principalement un outil de quiz self-paced, adapté aux devoirs à la maison et aux évaluations individuelles asynchrones. KartQuiz est conçu pour les sessions en direct : circuit visuel en temps réel, bonus d'attaque entre joueurs, course compétitive. Quizizz permet davantage d'activités asynchrones ; KartQuiz est plus fort sur la dynamique de groupe en présentiel.",
  },
  {
    q: 'KartQuiz remplace-t-il Wooclap pour les amphis ?',
    a: "Pas entièrement. Wooclap est optimisé pour le polling en temps réel, les nuages de mots et les questions ouvertes à grande échelle (1000+ personnes). KartQuiz est conçu pour des groupes jusqu'à 30 joueurs avec une compétition active. Dans un amphi de 200 étudiants, Wooclap reste plus adapté. En TD ou en petit groupe, KartQuiz apporte la dynamique compétitive que Wooclap n'a pas.",
  },
]
